<script setup>
import {onMounted, ref} from 'vue';
import {Capacitor} from '@capacitor/core';
import {authenticateWithBiometric, getAvailableTypeString} from '@/services/BiometricService';
import {getTenantData} from '@/services/TenantService';
import {BiometricAuth} from '@aparajita/capacitor-biometric-auth';
import {getBiometricLSKeyByDomain, isRebrandedTenant, setButtonContentLoading, setButtonContentSuccess} from '@/helper';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const biometricActive = ref(false);
const theme = ref({});
const biometricInfo = ref(null);
const biometricTypeAvailable = ref('');
const appName = isRebrandedTenant() ? 'B.I.G. Invest' : 'IN Equity';

onMounted(async () => {
  localStorage.removeItem(getBiometricLSKeyByDomain('BIOMETRIC_ACTIVE'));
  biometricInfo.value = await BiometricAuth.checkBiometry();
  biometricTypeAvailable.value = await getAvailableTypeString()
  getTenantData()
      .then((response) => {
        theme.value = response.theme;
      });
});

function activateBiometric() {
  biometricActive.value = true;
  localStorage.setItem(getBiometricLSKeyByDomain('BIOMETRIC_ACTIVE'), 'true');
  authenticateWithBiometric(false);
}

function redirectToDashboard() {
  setButtonContentLoading('btn-go-to-app');
  window.location.href = '/home';
}

</script>
<template>
  <div class="app-popup">
      <div class="row h-100 justify-content-center align-items-center p-2">
        <div class="col-md-4">
          <div class="app-popup__logo" v-if="theme && theme.logoBase64">
            <img :src="theme.logoBase64" v-if="theme && theme.logoBase64" alt="" />
          </div>
          <div class="app-popup__title">
            <div>{{ t('welcome.welcome_to_app') }}</div>
            <div>{{ t('welcome.in_equity', {appName}) }}</div>
          </div>
          <div class="app-popup__content">
            <div v-if="Capacitor.isNativePlatform() && biometricInfo?.isAvailable" class="row my-5">
              <div class="col-12 d-flex justify-content-center mb-2">
                <button id="btn-biometric-login" type="button" @click="activateBiometric()" class="btn btn--with-icon btn--face-id">
                  <span class="btn-icon"></span>
                  <span class="btn-content">{{ t('welcome.activate_login_using') }} {{biometricTypeAvailable}}</span>
                </button>
              </div>
              <div class="col-12 text-center">
                <small class="text-muted">{{ t('welcome.login_with') }} {{biometricTypeAvailable}} {{ t('welcome.activated_or_deactivate_at_settings') }}</small>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <button id="btn-go-to-app" @click="redirectToDashboard" class="btn btn-primary w-100"> <span>{{ t('welcome.go_to_application') }}</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

